export enum PresentationTypeEnum {
    line = 'LINE',
    bar = 'BAR'
}